<!-- COVERAGE -->
<section class="section">
  <div class="container">
    <div class="section-title">
      <h2>{{'cobertura.near_for_you' | translate}}</h2>
      <p>Llegamos a los principales estados de la República. Consulta tu código postal.</p>
    </div>

    <div class="cov-card">
      <video class="cov-video" #video autoplay muted loop playsinline>
        <source data-src="/assets/video/cobertura/web-640.webm" type="video/webm" />
        <source data-src="/assets/video/cobertura/web-640.mp4" type="video/mp4" />
      </video>
      <div class="cov-overlay"></div>
      <div class="cov-inner">
        <div class="globe">
          <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" width="54" height="54"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
        </div>
        <h3>Cobertura Nacional</h3>
        <p>{{'main.hashtag' | translate}}</p>
        <a routerLink="/cobertura" class="btn-cov">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><circle cx="12" cy="11" r="3"/></svg>
          {{'cobertura.see_coverage' | translate}}
        </a>
      </div>
    </div>
  </div>
</section>
